import { useState, useCallback, useRef } from 'react';
import { apiClient } from '../api/client';

// Espelha backend/app/schemas/audit_stats.py. Só contagens, nomes e rótulos.
export interface UsoPorPessoa { user_id: string; name: string; uses: number }
export interface UsoPorCredencial { credential_id: string; label: string; holder_name: string | null; uses: number }
export interface CredencialSemUso { credential_id: string; label: string; holder_name: string | null }
export interface UsoPorTitular { holder_id: string | null; holder_name: string | null; uses: number }
export interface FalhaDePreenchimento { page_host: string | null; reason: string | null; count: number }
export interface AbrirJaLogadoPorTribunal {
  key: string;
  label: string;
  logged_in: number;
  needs_user: number;
  failed: number;
  total: number;
  success_rate: number;
}
export interface CertificadoVencendo { certificate_id: string; label: string; not_after: string; days_to_expire: number }

export interface UsageStats {
  days: number;
  total_uses: number;
  active_people: number;
  top_people: UsoPorPessoa[];
  top_credentials: UsoPorCredencial[];
  unused_credentials_total: number;
  unused_credentials: CredencialSemUso[];
  uses_by_holder: UsoPorTitular[];
  autofill_failures: FalhaDePreenchimento[];
  autofill_failures_total: number;
  autologin_by_court: AbrirJaLogadoPorTribunal[];
  signatures: number;
  certificates_expiring_total: number;
  certificates_expiring: CertificadoVencendo[];
}

export function useUsageStats() {
  const [stats, setStats] = useState<UsageStats | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  // Troca rápida de período: só a resposta da última chamada vale.
  const ultimaChamada = useRef(0);

  const fetchStats = useCallback(async (days: number, userId?: string | null) => {
    const chamada = ++ultimaChamada.current;
    setIsLoading(true);
    setError(null);
    try {
      const data = await apiClient.get<UsageStats>(`/audit/stats?days=${days}${userId ? `&user_id=${encodeURIComponent(userId)}` : ''}`);
      if (chamada === ultimaChamada.current) setStats(data);
    } catch (err: any) {
      if (chamada === ultimaChamada.current) setError(err.message || 'Erro ao carregar estatísticas');
    } finally {
      if (chamada === ultimaChamada.current) setIsLoading(false);
    }
  }, []);

  return { stats, isLoading, error, fetchStats };
}
